// extracted by mini-css-extract-plugin
export default {"schoolInfoTitle":"school-information_schoolInfoTitle__GuUUh"};